module.exports = __webpack_public_path__ + "static/2-4235d0ca9e8f46a4b0583b813940535f.jpeg";